import { db } from "common/config/Firebase"

const invoicesCollection = db.collection('invoices')

const findInvoiceByIdUseCase = async ({ id }) => {
    const data = await invoicesCollection.doc(id).get()

    return data.data()
}

export default findInvoiceByIdUseCase